import React from "react";
const icon = (
  <svg
    width="576"
    height="384"
    viewBox="0 0 576 384"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M192 0C86 0 0 86 0 192C0 298 86 384 192 384H384C490 384 576 298 576 192C576 86 490 0 384 0H192ZM384 96C409.461 96 433.879 106.114 451.882 124.118C469.886 142.121 480 166.539 480 192C480 217.461 469.886 241.879 451.882 259.882C433.879 277.886 409.461 288 384 288C358.539 288 334.121 277.886 316.118 259.882C298.114 241.879 288 217.461 288 192C288 166.539 298.114 142.121 316.118 124.118C334.121 106.114 358.539 96 384 96Z"
      fill="#8803E9"
    />
  </svg>
);

export default icon;
